module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ClaimTerms", "Terms and conditions") ))==null?'':__t)+
'</legend><div class="scroll-frame"></div><div class="no-label"><input type="checkbox" id="terms-accept-input" data-input="terms-accept"> <label class="align-left" for="terms-accept-input">'+
((__t=( i18n.tc("ClaimTerms", "I have read and accepted the terms and conditions.") ))==null?'':__t)+
'</label></div></fieldset><fieldset class="button-wrap"><button data-click="terms-cancel">'+
((__t=( i18n.tc("ClaimTerms", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="terms-submit" disabled="disabled">'+
((__t=( i18n.tc("ClaimTerms", "Create subscription") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
